<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row class="ma-0 pa-0">
          <v-col justify="center" class="ma-0 pa-0">
            <v-card class="ma-0 pa-0" flat>
              
              <v-card-title class="justify-center headline font-weight-black ma-0 pa-0 mb-4" dense>
                    <span class="font-weight-black blue--text text--darken-4 title">{{ form14.wing }} Form 14</span>
                    {{previousRoute}}
              </v-card-title>
              <v-card-text>
                <v-form v-model="valid">
                  <span><hr color="black" class="ma-0 pa-0"/></span>
                  <v-container class="ma-0 pa-0">
                    <v-row>
                      <v-col class="ma-0 pa-0 mt-2">
                        <v-img 
                          :src="imageUrl"
                          contain
                          max-width="300px"
                          class="ml-auto mr-auto mt-3 mb-3"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="imageUrl == null || imageUrl == undefined" class="justify-center align-center text-center">
                      <v-col>
                        <span>Click the Camera icon to take a photo or select an existing image.</span><br />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="justify-center align-center text-center ma-0 pa-0" >
                        <v-icon color="blue darken-4" x-large @click="document.getElementById('mediaSelector').click()">mdi-camera</v-icon>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-file-input
                    
                    id="mediaSelector"
                    filled
                    prepend-icon="mdi-camera"
                    accept="image/jpeg,image/png,image/gif"
                    hide-input
                    @change="uploadImage($event)"
                    class="justify-center d-none"
                    width="50"
                  >
                  </v-file-input>

                  <!-- <picture-input
                    ref="pictureInput"
                    key="imageUrl"
                    class="mb-2 mt-2"
                    v-model="imageUrl"
                    height="300"
                    width="300"
                    :crop=false
                    accept="image/jpeg,image/png,image/gif"
                    button-class="BUTTON_OFQ"
                    removeButtonClass="BUTTON_OFQ"
                    removable
                    :custom-strings="{
                      upload: '<h1>Bummer!</h1>',
                      drag: 'Drag an image or <br>click here to select a file',
                      tap: 'Tap here to capture or select<br /> an image from the gallery'
                    }"
                    @change="changeImage">
                  </picture-input> -->

                  <span><hr color="black" class="mt-5" /><br /></span>

                  <v-select
                    :items="sortieTypes"
                    label="*Sortie Type"
                    dense
                    v-model="form14.sortietype"
                    outlined
                    :rules="[rules.required]"
                    placeholder="Select sortie type"
                  ></v-select>
<!-- 
                  <v-text-field
                    label="*CAP ID"
                    dense
                    v-model="form14.capid"
                    outlined
                    :rules="[rules.required, rules.numeric, rules.capid]"
                    placeholder=" "
                  ></v-text-field> -->

                  <v-text-field
                    label="*Mission Number"
                    dense
                    v-model="form14.mission"
                    outlined
                    :rules="[rules.required]"
                    placeholder=" "
                    v-uppercase
                  ></v-text-field>

                  <v-text-field
                    label="*Sorties for Receipt (comma separated)"
                    dense
                    v-model="form14.sorties"
                    outlined
                    :rules="[rules.required]"
                    placeholder=" "
                    v-uppercase
                  ></v-text-field>

                  <v-text-field
                    label="*Vendor Name"
                    dense
                    v-model="form14.vendorname"
                    placeholder=" "
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>

                  <v-text-field
                    label="*Vendor Location"
                    dense
                    v-model="form14.vendorlocation"
                    outlined
                    :rules="[rules.required]"
                    placeholder=" "
                  ></v-text-field>

                  <v-text-field
                    label="*Date of Service"
                    dense
                    v-model="form14.dateofservice"
                    outlined
                    :rules="[rules.required]"
                    placeholder=" "
                  ></v-text-field>

                  <v-text-field
                    label="*Purchaser Name"
                    dense
                    v-model="form14.purchasername"
                    outlined
                    :rules="[rules.required]"
                    placeholder=" "
                  ></v-text-field>

                  <v-text-field
                    v-if="form14.sortietype == 'Air'"
                    label="*Tail Number"
                    dense
                    v-model="form14.tailplateid"
                    outlined
                    :rules="[rules.required, rules.tailnumber]"
                    placeholder=" "
                    v-uppercase
                  ></v-text-field>

                  <v-text-field
                    v-if="form14.sortietype == 'Ground'"
                    label="*Vehicle ID / Plate #"
                    dense
                    v-model="form14.tailplateid"
                    outlined
                    :rules="[rules.required]"
                    placeholder=" "
                    v-uppercase
                  ></v-text-field>

                  <v-text-field
                    v-if="form14.sortietype == 'Air'"
                    label="*Total Flight Hours (Hobbs)"
                    dense
                    v-model="form14.hobbshrsmiles"
                    outlined
                    :rules="[rules.required, rules.decimal_1]"
                    placeholder=" "
                  ></v-text-field>

                  <v-text-field
                    v-if="form14.sortietype == 'Ground'"
                    label="*Total Miles Driven"
                    dense
                    v-model="form14.hobbshrsmiles"
                    outlined
                    :rules="[rules.required, rules.numeric]"
                    placeholder=" "
                  ></v-text-field>

                  <v-text-field
                    label="*Fuel Quantity (Gallons)"
                    dense
                    v-model="form14.fuelqtygal"
                    outlined
                    :rules="[rules.required, rules.decimal_min_2]"
                    placeholder=" "
                  ></v-text-field>

                  <v-text-field
                    label="*Fuel Price Per Gallon (Dollars)"
                    dense
                    v-model="form14.pricepergallon"
                    outlined
                    :rules="[rules.required, rules.decimal_min_2]"
                    placeholder=" "
                  ></v-text-field>

                  <v-text-field
                    label="Additional Costs (Dollars)"
                    dense
                    v-model="form14.addcosts"
                    outlined
                    :rules="[rules.decimal_2_or_empty]"
                    placeholder=" "
                  ></v-text-field>

                  <v-textarea
                    rows="2"
                    label="Additional Costs Desc."
                    dense
                    v-model="form14.addcostsdesc"
                    outlined
                    placeholder=" "
                    auto-grow
                  ></v-textarea>

                  <v-text-field
                    label="*Total Receipt (Dollars)"
                    dense
                    v-model="form14.totalfueladdcosts"
                    outlined
                    placeholder=" "
                    :rules="[rules.required, rules.decimal_2]"
                  ></v-text-field>

                  <v-text-field
                    label="CC CAP ID's (comma separated)"
                    dense
                    v-model="form14.cc_capids"
                    outlined
                    placeholder=" "
                  ></v-text-field>

                  <v-textarea
                    label="Explanation (if after 24 hours)"
                    rows="3"
                    dense
                    v-model="form14.post24hours"
                    outlined
                    placeholder=" "
                    auto-grow
                  ></v-textarea>
                </v-form>

              </v-card-text>

                <v-layout justify-center>
                  <v-card-actions>
                      <v-btn :disabled="submitDisabled()" class="white--text" color="blue darken-4" rounded @click="submitForm14()">Submit</v-btn>
                      <!-- <v-btn color="blue darken-4" rounded dark :to="{path:'/'}">Home</v-btn> -->
                  </v-card-actions>
                </v-layout>

              </v-card>

          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="actionModal"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        :color="dialogColor"
        dark
      >
        <v-card-text justify="center">
          <div v-show="loadingComplete == true && errorFound == false" class="text-center">
            <label class="white--text"><br />Your Form 14 has been submitted, please check your email which will contain the PDF document.</label>
          </div>
          <div v-show="loadingComplete == true && errorFound == true" class="text-center">
            <label class="white--text"><br />{{errorMsg}}</label>
          </div>
          <div v-show="loadingComplete != true">
            <label class="white--text" v-show="loadingComplete != true"><br />Submiting Data...</label>
            <v-progress-linear
              v-show="loadingComplete != true"
              indeterminate
              rounded
              color="white"
              class="mb-0"
              height="20px"
            ></v-progress-linear>
          </div>

        </v-card-text>

        <v-card-actions class="justify-center">
            <v-btn v-show="loadingComplete == true && errorFound == false" color="white" class="blue--text text--darken-4" :to="{path:'/home'}">Ok</v-btn>
            <v-btn v-show="loadingComplete == true && errorFound == true" color="white" class="red--text text--darken-4" :to="{path:'/home'}">Exit</v-btn>
            <span v-show="loadingComplete == true"><br /><br /></span>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>     
</template>

<script>

//import PictureInput from 'vue-picture-input';
//import imageCompression from 'browser-image-compression';

export default {
  name: 'form14',
  components: {
    //PictureInput
  },
  data() {
    return {
      document,
      dialogColor: 'blue darken-4',
      actionModal: false,
      loadingComplete: false,
      valid: true,
      dateOfServiceMenu:false,
      rawMissionNumber:'',
      showImageSelector: true,
      showImageReset: false,
      file: null,
      imageUrl: null,
      cameraModal: false,
      mediaStream: null,
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters.',
        capid: value => value.length == 6 || 'CAP ID must be 6 numbers.',
        numeric: value => !isNaN(value) || 'Must be numeric.',
        numeric_or_empty: value => {
          if(value != null && value != '')
          {
            return !isNaN(value) || 'Must be numeric.'
          }
          else
          {
            return true
          }
        },
        decimal_1: value => {
          const pattern = /^[0-9]+\.[0-9]$/
          return pattern.test(value) || 'Must include (1) decimal.'
        },
        decimal_2: value => {
          const pattern = /^[0-9]+\.[0-9][0-9]$/
          return pattern.test(value) || 'Must include (2) decimals.'
        },
        decimal_min_2: value => {
          const pattern = /^[0-9]+\.\d{2,3}$/
          return pattern.test(value) || 'Must include 2 or 3 decimals.'
        },
        decimal_2_or_empty: value => {

          if(value != null && value != '')
          {
            const pattern = /^[0-9]+\.[0-9][0-9]$/
            return pattern.test(value) || 'Must include (2) decimals.'
          }
          else
          {
            return true
          }
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        tailnumber: value => {
          const pattern = /^^N[0-9A-Z][0-9A-Z][0-9A-Z][0-9A-Z][0-9A-Z]$/
          return pattern.test(value) || 'Must be a valid Tail Number (Nxxxxx).'
        }
      },
      sortieTypes: [
        {text: "Air"},
        {text: "Ground"}
      ],
      form14: {
        emailaddress: '',
        formfilename: "cawgf14.pdf",
        fuelqtygal: '',
        image_receipt: '',
        tailplateid: '',
        vendorlocation: '',
        capid: '',
        hobbshrsmiles: '',
        post24hours: '',
        addcostsdesc: '',
        purchasername: '',
        totalfueladdcosts: '',
        addcosts: '',
        sorties: '',
        pricepergallon: '',
        vendorname: '',
        dateofservice:  new Date().toISOString().substr(0, 10),
        mission: '',
        wing: '',
        sortietype: '',
        cc_capids: ''
      },
      httpResponse:null,
      url: null,
      currentImage: null,
      errorFound: false,
      errorMsg:'',
      lastRoute: null
    }
  },
  mounted() {
    this.form14.wing = this.selWing
    this.form14.emailaddress = this.userInfo.email
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods:{
    handleMediaClick()
    {
      this.imageUrl = null
      this.$refs.mediaSelector.click();
    },
    uploadImage(value){

      if (value != undefined)
      {
        const reader = new FileReader();
        reader.readAsDataURL(value);
        reader.onload = e =>{
            this.imageUrl = e.target.result;
        };
      }
      else
      {
        this.imageUrl = null
      }
    },
    submitDisabled() {
      if(this.valid && this.imageUrl !=null && this.imageUrl !='')
      {
        return false;
      }
      else
      {
        return true;
      }
    },
    submitForm14() {
      //
      //Make the HTTP Post to validate the member

      console.log(this.form14);
      this.actionModal = true;

      if(this.form14.cc_capids != null)
      {
        var cleanString = this.form14.cc_capids.replace(/\s+/g, '');
        this.cc_capids = cleanString
      }

      const form14obj = {
        emailaddress: this.form14.emailaddress.toString(),
        formfilename: this.form14.formfilename.toString(),
        fuelqtygal: this.form14.fuelqtygal.toString(),
        image_receipt: this.imageUrl.toString(),
        tailplateid: this.form14.tailplateid.toString(),
        vendorlocation: this.form14.vendorlocation.toString(),
        capid: this.usercapid.toString(),
        //capid: "123456".toString(),
        hobbshrsmiles: this.form14.hobbshrsmiles.toString(),
        post24hours: this.form14.post24hours.toString(),
        addcostsdesc: this.form14.addcostsdesc.toString(),
        purchasername: this.form14.purchasername.toString(),
        totalfueladdcosts: this.form14.totalfueladdcosts.toString(),
        addcosts: this.form14.addcosts.toString(),
        sorties: this.form14.sorties.toString(),
        pricepergallon: this.form14.pricepergallon.toString(),
        vendorname: this.form14.vendorname.toString(),
        dateofservice:  (new Date().toISOString().substr(0, 10)).toString(),
        mission: this.form14.mission.toString(),
        wing: this.form14.wing.toString(),
        sortietype: this.form14.sortietype.toString(),
        cc_capids: this.form14.cc_capids.toString()
      }

      this.$https.post(this.$vars.BaseUrl + this.$vars.CreateForm14Route, form14obj, this.$vars.config)
        .then(response => {
          //console.log(response);
          this.httpResponse = response;
          this.dialogColor = 'blue darken-4'
          this.errorFound == false
          this.loadingComplete = true;
        })
        .catch(e => {
          var error = e;
          // eslint-disable-next-line no-console
          console.log(error.response);
          if (error.response.status == 400 && error.response.data == 'No Such User')
          {
            this.errorMsg = "The CAP ID (" + form14obj.capid + ") was not linked to a valid email address, this typically happens if the user is expired."
            this.dialogColor = 'red darken-4'
            this.errorFound = true
            this.loadingComplete = true;
          }
          else
          {
            this.errorMsg = error.response.statustext
            this.dialogColor = 'red darken-4'
            this.errorFound = true
            this.loadingComplete = true;
          }
        });
    }
  }
}
</script>

<style>

.BUTTON_OFQ {
  background: #3D94F6;
  background-image: -webkit-linear-gradient(top, #3D94F6, #1E62D0);
  background-image: -moz-linear-gradient(top, #3D94F6, #1E62D0);
  background-image: -ms-linear-gradient(top, #3D94F6, #1E62D0);
  background-image: -o-linear-gradient(top, #3D94F6, #1E62D0);
  background-image: linear-gradient(to bottom, #3D94F6, #1E62D0);
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  color: #FFFFFF;
  font-family: Verdana;
  font-size: 12px;
  font-weight: 100;
  padding: 6px;
  text-shadow: 1px 1px 20px #000000;
  border: solid #337FED 1px;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
}

.BUTTON_OFQ:hover {
  background: #1E62D0;
  background-image: -webkit-linear-gradient(top, #1E62D0, #3D94F6);
  background-image: -moz-linear-gradient(top, #1E62D0, #3D94F6);
  background-image: -ms-linear-gradient(top, #1E62D0, #3D94F6);
  background-image: -o-linear-gradient(top, #1E62D0, #3D94F6);
  background-image: linear-gradient(to bottom, #1E62D0, #3D94F6);
  text-decoration: none;
}

.darkBlueText {
  color:midnightblue;
}

.rec_img {
  height:100vh;
}

</style>
